import _ from 'lodash';
import $ from 'jquery';
import angular from 'angular';
import template from './employerView.html';
import logger from '../../../shared/logger';
import './style.scss';
import UtilsService from '../../../services/utilsService';
import { EMPLOYER_REP_ROLES } from "../employerRep/constants/roles";

export class EmployerComponent {
    /* @ngInject */
    constructor(
        AuthService,
        RecruiterService,
        EmployerService,
        $cookies,
        $translate,
        OfficeService,
        permissions,
        RouteService,
        $state,
        NotificationService,
        $stateParams,
        Restangular,
        $rootScope,
        EmployerRepService,
        WebAppRouteService,
        $uibModal,
        $localStorage,
        DocumentService,
    ) {
        const employerCtrl = this;

        const isTalenyaUser = permissions.isTalenyaUser();
        const isTalentExpertUser = permissions.isTalentExpertUser();

        if (isTalenyaUser) {
            this.talenyaUser = true;
        }

        if (isTalentExpertUser) {
            this.talentExpertUser = true;
        }

        employerCtrl.officeGroups = [];
        const groupVisibilityState = {};
        const employersPerOfficeLimitState = {};
        employerCtrl.employersPerOffice = {};
        employerCtrl.MAX_EMPLOYERS_TO_DISPLAY = RouteService.getSystemPreference('appMenuMaxEmployersPerOfficeQuantity') || 5;
        employerCtrl.employerNameSearchValue = '';

        employerCtrl.setGroupVisibility = (group, isVisible) => {
            groupVisibilityState[group] = isVisible ?? !groupVisibilityState[group];
        };

        employerCtrl.closeAllEmployerOffices = () => {
            for (const office in employerCtrl.employersPerOffice) {
                employerCtrl.setGroupVisibility(office, false);
            }
        };

        employerCtrl.isGroupVisible = (group) => groupVisibilityState[group];

        employerCtrl.setEmployersPerOfficeLimitState = () => {
            for (const officeName in employerCtrl.employersPerOffice) {
                const employersQty = employerCtrl.employersPerOffice[officeName].length;
                employersPerOfficeLimitState[officeName] = employersQty > employerCtrl.MAX_EMPLOYERS_TO_DISPLAY;
            }
        };

        employerCtrl.isGroupLimited = (office) => employersPerOfficeLimitState[office];

        employerCtrl.toggleLimitState = (office) => {
            employersPerOfficeLimitState[office] = !employersPerOfficeLimitState[office];
        };

        employerCtrl.clearEmployerNameSearch = () => {
            employerCtrl.employerNameSearchValue = '';
            employerCtrl.employersFilteredByName = employerCtrl.employers;
            employerCtrl.employersPerOffice = employerCtrl.getEmployersPerOffice(employerCtrl.employers);
            employerCtrl.setEmployersPerOfficeLimitState();
            employerCtrl.closeAllEmployerOffices();
        };

        employerCtrl.getEmployersPerOffice = (employers) => _.reduce(employers, (acc, employer) => {
            const officeName = employer.office;
            acc[officeName] = acc[officeName] ? [...acc[officeName], employer] : [employer];
            return acc;
        }, {});

        employerCtrl.manageUsersState = ($state.current.name == 'employer.manageUsers');

        $rootScope.$on('$stateChangeStart', (event, next) => {
            employerCtrl.manageUsersState = (next.name == 'employer.manageUsers');
        });

        employerCtrl.init = (async () => {
            OfficeService.getOffices()
                .then((response) => {
                    const { result: officeGroups = employerCtrl.officeGroups } = response || {};
                    employerCtrl.officeGroups = officeGroups;
                    employerCtrl.officeGroups.forEach((group) => {
                        groupVisibilityState[group] = !isTalenyaUser;
                    });
                })
                .catch((err) => logger.error(err));

            UtilsService.cookiesOverride($cookies);
            const origUserPrefs = UtilsService.parseJSON($cookies.get('origUserPrefs'));
            const userPrefs = UtilsService.parseJSON($cookies.get('userprefs'));
            const userData = UtilsService.parseJSON($cookies.get('userData'));

            const checkPermission = permissions.isEmployerUser() && (!permissions.isTalentExpertUser()) && (!isTalenyaUser);

            if (checkPermission) {
                if (!origUserPrefs) {
                    return AuthService.logout();
                }
            }

            employerCtrl.userPicture = RouteService.getUserData('picture');

            if (isTalenyaUser) {
                employerCtrl.talenyaUser = true;
                RecruiterService.getAllRecruitersForMenu()
                    .then((response) => {
                        employerCtrl.recruiters = _.get(response, 'result', []);
                        employerCtrl.currentUsers = _.remove(employerCtrl.recruiters, (recruiter) => {
                            if (userPrefs.entityId === recruiter._id) {
                                return true;
                            }
                            if (recruiter.contact) {
                                for (let i = 0; i < recruiter.contact.email.length; i++) {
                                    if (recruiter.contact.email[i].value === userData?.email) {
                                        return true;
                                    }
                                }
                            }
                            return false;
                        });
                    })
                    .catch((err) => logger.error(err));

                EmployerService.getAllEmployersForMenu()
                    .then(({ result: employers }) => {
                        employerCtrl.employers = _.orderBy(employers, ['settings.isResellerPartner', 'name'], ['desc', 'asc']);
                        employerCtrl.employersFilteredByName = employers;
                        employerCtrl.employersPerOffice = employerCtrl.getEmployersPerOffice(employerCtrl.employers);
                        employerCtrl.clearEmployerNameSearch();
                        employerCtrl.setEmployersPerOfficeLimitState();
                    })
                    .catch((err) => logger.error(err));

                employerCtrl.onEmployerFilterChange = function () {
                    employerCtrl.employersFilteredByName = employerCtrl.employers.filter(
                        (e) => _.includes(_.toLower(e.name), _.toLower(employerCtrl.employerNameSearchValue)),
                    );

                    employerCtrl.employersPerOffice = employerCtrl.getEmployersPerOffice(employerCtrl.employersFilteredByName);
                    employerCtrl.setEmployersPerOfficeLimitState();

                    for (const group in groupVisibilityState) {
                        groupVisibilityState[group] = !_.isEmpty(employerCtrl.employerNameSearchValue);
                    }
                };

                OfficeService.getOfficeGroups()
                    .then((response) => {
                        const { result: officeGroups = employerCtrl.officeGroups } = response || {};
                        employerCtrl.officeGroups = officeGroups;
                    })
                    .catch((err) => logger.error(err));

                await EmployerService.getEmployer($stateParams.employerId)
                    .then((response) => {
                        employerCtrl.employerData = _.get(response, 'result') || {};
                    }, (error) => {
                        logger.error(error);
                        NotificationService.error('Logout and Login');
                    })
                    .catch((err) => logger.error(err));

                if (userData?.roles?.indexOf('EM') >= 0 && origUserPrefs?.employerRepId) {
                    EmployerRepService.getEmployersRepSearch({ employerId: $stateParams.employerId })
                        .then((response) => {
                            const employerReps = response.result;
                            const index = _.findIndex(employerReps, { _id: origUserPrefs.employerRepId });
                            if (index >= 0) {
                                employerCtrl.employerRepData = employerReps[index];
                            }
                        })
                        .catch((err) => logger.error(err));
                }
            } else if (userData?.roles?.indexOf('AM') >= 0) {
                employerCtrl.accountManager = true;
                EmployerService.getEmployers()
                    .then((response) => {
                        employerCtrl.employers = response.result;
                    })
                    .catch((err) => logger.error(err));

                await EmployerService.getEmployer($stateParams.employerId)
                    .then((response) => {
                        employerCtrl.employerData = _.get(response, 'result') || {};
                    }, (error) => {
                        logger.error(error);
                        NotificationService.error('Logout and Login');
                    });
            } else if (permissions.isTalentExpertUser() && userPrefs?.entityId) {
                employerCtrl.talentExpert = true;
                RecruiterService.getRecruiter(userPrefs?.entityId)
                    .then((response) => {
                        employerCtrl.talentExpertData = response.result;
                    })
                    .catch((err) => logger.error(err));
                await EmployerService.getEmployer($stateParams.employerId)
                    .then((response) => {
                        employerCtrl.employerData = _.get(response, 'result') || {};
                    }, (error) => {
                        logger.error(error);
                        NotificationService.error('Logout and Login');
                    });
            } else if ((userData?.roles?.indexOf('EM') >= 0 || !userData?.roles) && origUserPrefs?.employerRepId) {
                await EmployerRepService.getExistingEmployerRep(origUserPrefs?.employerRepId)
                    .then(async (response) => {
                        employerCtrl.employerRepData = response.result;
                        if (employerCtrl?.employerRepData?.status?.current !== 'active' || employerCtrl?.employerRepData?.removed === true) {
                            NotificationService.error('UNAUTHORIZED_TO_ACCESS_EMPLOYER_REP');
                            return $state.go('logout');
                        }
                        await EmployerService.getEmployer($stateParams.empId)
                            .then((response) => {
                                employerCtrl.employerData = response.result;
                                employerCtrl.searchData = {
                                    type: 'employer',
                                    entityId: employerCtrl.employerData._id,
                                };

                                const isEmployerRepAdmin = _.get(employerCtrl, 'employerRepData.roles', []).includes(EMPLOYER_REP_ROLES.ADMIN);
                                const isResellerPartner = _.get(employerCtrl, 'employerData.isResellerPartner', false);
                                const resellerEmployerId = _.get(employerCtrl, 'employerData.resellerEmployerId', false);
                                const isPaycorEmployerRedAdmin = isEmployerRepAdmin && resellerEmployerId && !isResellerPartner;

                                DocumentService.changeFavicon(isPaycorEmployerRedAdmin);
                            }, (error) => {
                                logger.error(error);
                                NotificationService.error('LOGUT_AND_LOGIN');
                            });
                    });
            }
            $localStorage.employerData = employerCtrl.employerData;
            if (employerCtrl?.employerData?.resellerEmployerId && employerCtrl.employerData._id !== employerCtrl?.employerData?.resellerEmployerId) {
                await EmployerService.getReseller(employerCtrl.employerData._id)
                    .then((response) => {
                        $localStorage.resellerData = response?.result;
                    });
            }
            employerCtrl.tftMainLogoUrl = await RouteService.getThemeSettingsAsync('tftMainLogoUrl') || '';
        })();

        employerCtrl.toggleMenu = function () {
            $('.background')
                .toggle();
            $('.navbar-nav-menu')
                .toggle();
            employerCtrl.showMenu = !employerCtrl.showMenu;

            if (!employerCtrl.showMenu) {
                employerCtrl.clearEmployerNameSearch();
            }
        };

        employerCtrl.closeMenu = function () {
            if (employerCtrl.showMenu == true) {
                employerCtrl.toggleMenu();
            }
        };

        employerCtrl.goPositionsPage = (employerId) => {
            WebAppRouteService.goPositionsPage({
                employerId,
            });
        };

        employerCtrl.activateEmployer = function () {
            EmployerService.activateEmployer(employerCtrl.employerData._id)
                .then(() => {
                    employerCtrl.goPositionsPage(employerCtrl.employerData._id);
                })
                .catch((err) => logger.error(err));
        };

        employerCtrl.deActivateEmployer = function () {
            EmployerService.deactivateEmployer(employerCtrl.employerData._id)
                .then(() => {
                    employerCtrl.goPositionsPage(employerCtrl.employerData._id);
                })
                .catch((err) => logger.error(err));
        };

        employerCtrl.editEmployer = function () {
            $state.go(
                'employer.editEmployer',
                { empId: employerCtrl.employerData._id },
            );
        };

        employerCtrl.openEmployerCampaignsPage = function () {
            const isEmployerRep = _.get(employerCtrl.employerRepData, 'roles', []).includes('EM_REP_ADMIN');
            const employerId = isEmployerRep ? employerCtrl.employerData._id : $stateParams.employerId;

            WebAppRouteService.goToEmployerCampaignsPage({
                employerId,
            });
        };

        employerCtrl.viewCampaigns = (goToPssCampaigns = false) => {
            const isEmployerRep = _.get(employerCtrl.employerRepData, 'roles', []).includes('EM_REP_ADMIN');
            const employerId = isEmployerRep ? employerCtrl.employerData._id : $stateParams.employerId;

            const isCampaignsAnalysisPageEnabled = _.get(employerCtrl, 'employerData.settings.isCampaignsAnalysisPageEnabled', false);
            if (!isCampaignsAnalysisPageEnabled) {
                return;
            }
            
            if (goToPssCampaigns) {
                WebAppRouteService.goToPSSCampaignsActivityPage({
                    employerId
                })
            }
            else {
                WebAppRouteService.goToCampaignsActivityPage({
                    employerId,
                });
            }
        };

        employerCtrl.manageEmployerReps = () => {
            const isEmployerRep = _.get(employerCtrl.employerRepData, 'roles', []).includes('EM_REP_ADMIN')
                || _.get(employerCtrl.employerRepData, 'roles', []).includes('EM_REP_USER');
            const employerId = isEmployerRep ? employerCtrl.employerData._id : $stateParams.employerId;

            WebAppRouteService.goToManageEmployerRepDetails({
                employerId,
            });
        };

        employerCtrl.manageCurrentEmployerRep = async () => {
            const { employerId } = $stateParams;

            if (!employerId) {
                return;
            }

            UtilsService.cookiesOverride($cookies);

            const origUserPrefs = UtilsService.parseJSON($cookies.get('origUserPrefs'));
            const { result: employerRep } = await EmployerRepService.getExistingEmployerRep(origUserPrefs?.employerRepId);

            const modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                component: 'editEmployerRepModalCtrl',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    employerRep: () => _.cloneDeep(employerRep),
                },
            });

            modalInstance
                .result
                .then((updatedEmployerRep) => EmployerRepService.updateExistingEmployerRep(employerRep._id, updatedEmployerRep))
                .then(() => {
                    NotificationService.success('DEFAULT_NOTIFICATION_CHANGES_SAVED');
                })
                .catch((err) => {
                    if (err) {
                        logger.error(err);
                        NotificationService.error(err.message);
                    }
                });
        };

        employerCtrl.refreshLists = function () {
            RouteService.getRefreshMetaData()
                .catch((err) => logger.error(err));
        };

        employerCtrl.logout = function () {
            AuthService.logout(true);
        };
    }
}

export const EmployerComponentConfiguration = {
    template,
    controller: EmployerComponent,
    controllerAs: 'employerCtrl',
};

angular
    .module('TALENYA-FE')
    .component('employerComponent', EmployerComponentConfiguration);
